import React from 'react';
import type {InputProps} from '@rneui/base';
import {withTheme} from '@rneui/themed';

import TextInput from '../ui-controls/form/TextInput';

type ThemedTextInputProps = InputProps & {largeText?: boolean};

export default withTheme<ThemedTextInputProps>(
  TextInput,
  'TextInput',
) as React.FC<ThemedTextInputProps>;

declare module '@rneui/themed' {
  export interface ComponentTheme {
    TextInput: Partial<ThemedTextInputProps>;
  }
}
